import { CIEColorSystem, constrainRGB, gammaCorrectRGB, HDTVColorSystem, normRGB, spectrumToXYZ, wavelengthToColor, xData, xyzToRGB, yData, zData } from './colorData';

import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Slider } from 'office-ui-fabric-react/lib/Slider';

import * as d3 from 'd3';

import Interactable from './InteractableReact';

import * as React from 'react';

import { autobind } from '@uifabric/utilities/lib';



interface IChartProps {
    width: number;
    height: number;
    colorChanged: (color: string) => void;
    data: Array<[number,number]>;
}

interface IChartState {
    color: string;
    debug: string;
    isDown: boolean;
    intensity: number;
}


class Chart extends React.Component<IChartProps, IChartState> {

    private data: Array<[number, number]>;
    private ref: SVGSVGElement;
    private canvas: HTMLCanvasElement;
    private dataContainer: d3.Selection<any, any, any, any>;
    private drawContext: CanvasRenderingContext2D;

    private x: any;
    private y: any;

    private line: d3.Line<[number, number]>;

    private isMouseDown: boolean;

    constructor(props: IChartProps) {
        super(props);

        this.isMouseDown = false;

        this.data = new Array<[number, number]>();
        this.resetData();

        // this.handleInputMove = this.handleInputMove.bind(this);
        // this.resetData = this.resetData.bind(this);
        // this.handleSliderInput = this.handleSliderInput.bind(this);

        this.state = { color: '#ffffff', debug: 'debug', isDown: false, intensity: 100 };

        window.addEventListener('touchmove',(ev)=>{
            if(this.isMouseDown){
                ev.preventDefault();
            }
        });
    }

    public componentDidUpdate(prevProps: IChartProps, prevState: IChartState){
        console.log("ComponentDidUpdate", prevProps.data, this.props.data);
        if (prevProps.data !== this.props.data){
            this.data = this.props.data;
            const changes = this.dataContainer.selectAll('custom.circle')
                    .data(this.data, dd => dd[0]);

                // console.log(changes);
                changes.attr('cx', (dd: [number, number]) => this.x(dd[0]))
                    .attr('cy', (dd: [number, number]) => this.y(dd[1]));

                const backColor = this.calculateColor();
                // console.log('backColor', backColor);

                const rect = this.dataContainer.select('custom.rect');
                rect.attr('fill', backColor);

                this.drawCanvas();

        }
    }

    public componentDidMount() {

        if (this.props.data.length > 0){
            this.data = this.props.data;
        }
        console.log('componentDidMount');
        
        this.x = d3.scaleLinear().domain([360, 760]).range([30, this.props.width - 20]);
        this.y = d3.scaleLinear().domain([2, 0]).range([40, this.props.height - 50]);

        // console.log(x);
        // console.log(y);
        const xAxis = d3.axisBottom(this.x);
        const yAxis = d3.axisLeft(this.y);
        //   const xAxis = d3.axaxis().scale(x).orient("bottom"),
        //   const yAxis = d3.svg.axis().scale(y).orient("left");

        const svg = d3.select(this.ref)
            // .style('border', '1px red solid')
            .style('-ms-user-select', 'none')
            .style('-webkit-touch-callout', 'none')
            .style('-webkit-user-select', 'none')
            .style('-khtml-user-select', 'none')
            .style('-moz-user-select', 'none')
            .style('user-select', 'none')
            ;

        const canvas = d3.select(this.canvas);
        this.drawContext = this.canvas.getContext('2d') as CanvasRenderingContext2D;

        const detachedContainer = document.createElement('custom');
        this.dataContainer = d3.select(detachedContainer);

        svg.on('mousedown', () => { this.isMouseDown = true; this.setState({ isDown: true }); });
        svg.on('mouseup', () => { this.isMouseDown = false; this.setState({ isDown: false }); });
        svg.on('mouseleave', () => this.isMouseDown = false);
        svg.on('mousemove', this.handleInputMove);
        svg.on('touchstart', () => { this.isMouseDown = true; this.setState({ isDown: true }); });
        svg.on('touchend', () => { this.isMouseDown = false; this.setState({ isDown: false }); });
        svg.on('touchmove', this.handleInputMove);

        svg.append('g')
            .attr('transform', () => 'translate(' + 0 + ',' + (this.props.height - 50) + ')').call(xAxis);
        svg.append('g')
            .attr('transform', () => 'translate(' + 30 + ',' + 0 + ')').call(yAxis);

        svg.append("text")
            .attr("class", "x label")
            .attr("text-anchor", "end")
            .attr("x", this.props.width/2)
            .attr("y", this.props.height - 6)
            .text("Wavelength (nm)");

        const dataBinding = this.dataContainer.selectAll("custom.circle")
            .data(this.data);

        dataBinding
            .attr("size", 15)
            .attr("fillStyle", "green");

        // for new elements, create a 'custom' dom node, of class rect
        // with the appropriate rect attributes
        dataBinding.enter()
            .append("custom")
            .classed("circle", true)
            .attr('cx', (d: [number, number]) => this.x(d[0]))
            .attr('cy', (d: [number, number]) => this.y(d[1]))
            .attr('r', 4)
            .attr("fillStyle", (d: [number, number]) => wavelengthToColor(d[0]));

        const dataBinding2 = this.dataContainer.selectAll("custom.rect")
            .data(this.data);

        dataBinding2.enter()
            .append('custom')
            .classed("rect", true)
            .attr('width', this.props.width - 20)
            .attr('height', this.props.height - 50)
            .attr('fill', '#ffffff');

        this.line = d3.line()
            .x(d => this.x(d[0]))
            .y(d => this.y(d[1]))
            .context(this.drawContext).bind(this);

        this.drawCanvas();
    }



    public render() {

        const { width, height } = this.props;

        return (
            <div style={{ textAlign: 'left' }}>
                <div style={{ display: 'flex' }}>
                    <PrimaryButton onClick={this.resetData}>reset</PrimaryButton>
                    <div style={{ width: 300 }}>
                        <Slider
                            min={10}
                            max={100}
                            step={10}
                            value={this.state.intensity}
                            showValue={true}
                            label='Color Intensity'
                            onChange={this.handleSliderInput}
                        />
                    </div>
                </div>
                <div style={{ position: 'relative', left: 0 }}>

                    <canvas width={width} height={height} ref={(ref: HTMLCanvasElement) => this.canvas = ref} style={{ position: 'absolute', left: 0 }} />
                    <svg className="container" width={width} height={height} ref={(ref: SVGSVGElement) => this.ref = ref} style={{ position: 'absolute', left: 0 }} />
                    {/* <div>{this.state.debug}</div>
                    <div>{this.state.isDown.toString()}</div> */}

                </div>
                {/* <div>{JSON.stringify(this.props.data)}</div> */}
            </div>
        );

    }


    private calculateColor(): string {
        // console.log(this.data);
        const xyzColor = spectrumToXYZ(this.data);
        // console.log('xyzColor', xyzColor);
        const rgbColor = xyzToRGB(CIEColorSystem, xyzColor[0], xyzColor[1], xyzColor[2]);
        // console.log('rgbColor', rgbColor);

        const constrainedColor = constrainRGB(rgbColor);
        // console.log('constrainedColor', constrainedColor);
        const normColor = normRGB(constrainedColor);
        // console.log('normColor', normColor);
        // const gammaCorrectedColor = gammaCorrectRGB(HDTVColorSystem, constrainedColor);
        // const normColor = normRGB(gammaCorrectedColor);
        const hexColor = '#' + this.normalizedDecToHex(normColor[0]) + this.normalizedDecToHex(normColor[1]) + this.normalizedDecToHex(normColor[2]);
        
        const rgbaColor = this.colorAlphaToFill(normColor);
        this.setState({ 'color': rgbaColor });
        // console.log(rgbaColor);
        this.props.colorChanged(rgbaColor);
        return rgbaColor;
    }

    @autobind
    private handleInputMove() {
       
        this.setState({ debug: 'moving' });
        try {
            d3.event.preventDefault();
            if (this.isMouseDown) {
                // console.log(d3.clientPoint(d3.event.srcElement, d3.event));
                // this.setState({ debug: d3.clientPoint(d3.event.srcElement, d3.event).toString() })

                let pointX = this.x.invert(d3.event.offsetX);
                let pointY = this.y.invert(d3.event.offsetY);

                if (isNaN(d3.event.offsetX)) {
                    const mousePoint = d3.mouse(d3.event.srcElement);
                    this.setState({ debug: mousePoint.toString() });
                    pointX = this.x.invert(mousePoint[0]);
                    pointY = this.y.invert(mousePoint[1]);
                }


                if (pointY < 0) {
                    pointY = 0;
                }
                const closest = this.data.reduce((prev, curr) => {
                    return (Math.abs(curr[0] - pointX) < Math.abs(prev[0] - pointX) ? curr : prev);
                });
                const index = this.data.indexOf(closest);
                const updateData = [[closest, pointY]];

                // update original
                this.data[index][1] = pointY;
                const changes = this.dataContainer.selectAll('custom.circle')
                    .data(this.data, dd => dd[0]);

                // console.log(changes);
                changes.attr('cx', (dd: [number, number]) => this.x(dd[0]))
                    .attr('cy', (dd: [number, number]) => this.y(dd[1]));

                const backColor = this.calculateColor();
                // console.log('backColor', backColor);

                const rect = this.dataContainer.select('custom.rect');
                rect.attr('fill', backColor);

                this.drawCanvas();


            }
        }
        catch (e) {
            this.setState({ debug: JSON.stringify(e) });
        }
    }

    @autobind
    private handleSliderInput(c: any) {
        this.setState({ intensity: c });
        this.drawCanvas();
    }

    private normalizedDecToHex(val: number): string {
        if (val < 0) {
            val = 0;
        }
        let hex = Math.floor(val * 255).toString(16);
        if (hex.length === 1) {
            hex = '0' + hex;
        }
        return hex;
    }

    @autobind
    private colorAlphaToFill(color: [number, number, number]): string {
        const r = color[0] * 255;
        const g = color[1] * 255;
        const b = color[2] * 255;
        return 'rgba(' + Math.round(r) + ', ' + Math.round(g) + ', '  + Math.round(b) + ', ' + this.state.intensity / 100 + ')';
    }

    @autobind
    private resetData() {
        this.data.length = 0;
        for (let i = 0, lambda = 360; i < xData.length; i++ , lambda += 5) {
            this.data.push([lambda, 0]);
        }
        if (this.drawContext != null) {
            this.dataContainer.selectAll("custom.circle")
                .remove();
            const dataBinding = this.dataContainer.selectAll("custom.circle")
                .data(this.data);

            dataBinding
                .attr("size", 15)
                .attr("fillStyle", "green");

            // for new elements, create a 'custom' dom node, of class rect
            // with the appropriate rect attributes
            dataBinding.enter()
                .append("custom")
                .classed("circle", true)
                .attr('cx', (d: [number, number]) => this.x(d[0]))
                .attr('cy', (d: [number, number]) => this.y(d[1]))
                .attr('r', 4)
                .attr("fillStyle", (d: [number, number]) => wavelengthToColor(d[0]));

            this.calculateColor();

            this.drawCanvas();

        }
    }

    @autobind
    private drawCanvas() {

        const chart = d3.select('canvas');
        // clear canvas
        this.drawContext.clearRect(0, 0, this.props.width, this.props.height);

        this.drawContext.fillStyle = "red";

        const rectElement = this.dataContainer.select('custom.rect');
        // rectElements.each((d:any,i:number,nodes:any)=>{
        // const node = d3.select(rectElement[1]);
        this.drawContext.rect(30, 40, +rectElement.attr('width') - 30, +rectElement.attr('height')-40);
        this.drawContext.fillStyle = this.calculateColor();
        // console.log('rectElement.attr(fill)', this.drawContext.fillStyle);
        this.drawContext.fill();

        // });

        const elements = this.dataContainer.selectAll("custom.circle");

        // console.log(elements);
        elements.each((d: any, i: number, nodes: any) => {
            const node = d3.select(nodes[i]);
            //   console.log(d);
            //   console.log(i);
            //   console.log(nodes);
            //   console.log(node);

            this.drawContext.beginPath();
            // this.drawContext.fillStyle = node.attr("fillStyle");
            this.drawContext.arc(+node.attr("cx"), +node.attr("cy"), +node.attr("r"), 0, 2 * Math.PI);
            this.drawContext.fillStyle = node.attr('fillStyle');
            this.drawContext.fill();
            this.drawContext.closePath();
            if (d[0] < 760) {
                this.drawContext.beginPath();
                this.drawContext.lineWidth = 1;
                // (this.drawContext as any).opacity=0.5;
                this.line(this.data);
                this.drawContext.stroke();

                this.drawContext.closePath();
            }
        });


    }


}

export default Chart;



// WEBPACK FOOTER //
// ./src/Chart.tsx